import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiPromotedSitter, ApiSitter } from '@app/packages/api/v2/types/entities'
import type { SitterAvailabilityCheckRequest } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getSittersByIdAvailability = (id: string, request: SitterAvailabilityCheckRequest) =>
  createApiAction('getSittersByIdAvailability', dispatch =>
    dispatch<unknown>({ method: 'GET', endpoint: v2Path(urlEscaped`/api/v2/sitters/${id}/availability`, request) })
  )

export const getSittersPromoted = () =>
  createApiAction('getSittersPromoted', dispatch => dispatch<{ data: ApiPromotedSitter[] }>({ method: 'GET', endpoint: '/api/v2/sitters/promoted' }))

export const getSittersTrusted = () =>
  createApiAction('getSittersTrusted', dispatch => dispatch<{ data: ApiSitter[] }>({ method: 'GET', endpoint: '/api/v2/sitters/trusted' }))

export const postSittersTrusted = (sitter_id: string) =>
  createApiAction('postSittersTrusted', dispatch => dispatch<unknown>({ method: 'POST', endpoint: urlEscaped`/api/v2/sitters/trusted/${sitter_id}` }))

export const deleteSittersTrusted = (sitter_id: string) =>
  createApiAction('deleteSittersTrusted', dispatch => dispatch<unknown>({ method: 'DELETE', endpoint: urlEscaped`/api/v2/sitters/trusted/${sitter_id}` }))
